"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentClient = void 0;
const tslib_1 = require("tslib");
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const debug = !process.env.AWS_SESSION_TOKEN && false;
const defaultDynamoDBClientConfig = {
    apiVersion: config_1.default.aws.dynamoDB.apiVersion,
    region: config_1.default.aws.default_region,
    useDualstackEndpoint: false // 2025 10 VPC has FOC DynamoDB v4 endpoint so don't use IPv6 as the dynamodb.ap-southeast-2.api.aws endpoint does not work - or is a translation from v6 to v4
};
const defaulMarshallOptions = {
    // Whether to automatically convert empty strings, blobs, and sets to `null`.
    convertEmptyValues: false, // false, by default.
    // Whether to remove undefined values while marshalling.
    removeUndefinedValues: true, // false, by default.
    // Whether to convert typeof object to map attribute.
    convertClassInstanceToMap: true, // false, by default.
};
const defaultUnmarshallOptions = {
    // Whether to return numbers as a string instead of converting them to native JavaScript numbers.
    wrapNumbers: false, // false, by default.
};
const defaultTranslateConfig = { marshallOptions: defaulMarshallOptions, unmarshallOptions: defaultUnmarshallOptions };
const getDocumentClient = ({ dynamoDBClientConfig = defaultDynamoDBClientConfig, translateConfig = defaultTranslateConfig }) => {
    const client = new client_dynamodb_1.DynamoDBClient(dynamoDBClientConfig);
    return lib_dynamodb_1.DynamoDBDocumentClient.from(client, translateConfig);
};
exports.getDocumentClient = getDocumentClient;
